export const INFO_SECURITY_TEXT = 'Your data security is our priority.';
